import React from 'react'
import { FormBox } from './FormBox'
import { RadioListBox } from './RadioListBox'
import styles from './DataGridFilter.less'
import { ah, ReduxWrapper, compose, pt } from 'common-data/datahelpers'
import { ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText } from 'reactstrap'
import _ from 'common-tools/LodashHelper'
import { componentGetCompareProps } from 'common-tools/index'
import { FieldValueConverters } from './FieldValueConverters'

export class DataGridFilterPlain extends React.Component {
  static propTypes = {
    formName: pt.string.isRequired,
    onSubmit: pt.func.isRequired,
    icon: pt.string.isRequired,
    loading: pt.bool.isRequired,
    children: pt.oneOfType([pt.arrayOf(pt.element), pt.element]),
    hide: pt.bool.isRequired,
    sortOptions: pt.arrayOf(pt.shape({
      Text: pt.string,
      Value: pt.any
    })),
    initialValues: pt.shape({
      Limit: pt.oneOfType([pt.number, pt.string]).isRequired,
      SortBy: pt.string,
      Filters: pt.any
    }),
    alwaysSendFilterPropNames: pt.array
  }

  static defaultProps = {
    hide: false,
    loading: false,
    icon: 'filter',
    sortOptions: [],
    initialValues: {
      Limit: 0,
      SortBy: '',
      Filters: {}
    },
    alwaysSendFilterPropNames: []
  }

  reset () {
    const { formResetValues, formName } = this.props
    formResetValues(formName)
  }

  getItems (children, sortOptions, initialValues) {
    const ret = {
      filters: [],
      showReset: {}
    }

    let items = []

    if (_.isArray(children)) {
      items = _.concat([], children)
    } else {
      items.push(children)
    }

    if (_.isArray(sortOptions) && initialValues.SortBy) {
      if (sortOptions.length > 0) {
        items.push(<ListGroupItem key='sort'>
          <ListGroupItemHeading>Sort</ListGroupItemHeading>
          <ListGroupItemText>How to sort the results.</ListGroupItemText>
          <RadioListBox options={sortOptions} name='SortBy' />
        </ListGroupItem>)
      }
    }

    if (initialValues.Limit < 101) {
      items.push(<ListGroupItem key='limit' tabid='limit'>
        <ListGroupItemHeading>Limit</ListGroupItemHeading>
        <ListGroupItemText>How many items to show initially.  Clicking the load more will fetch this many more items each time.</ListGroupItemText>
        <RadioListBox options={[{ Value: 10 }, { Value: 25 }, { Value: 50 }, { Value: 100 }, { Value: 1000 }]} fieldType={FieldValueConverters.Int} name='Limit' />
      </ListGroupItem>)
    }

    ret.filters = items

    return ret
  }

  onSubmit (values) {
    const { onSubmit, initialValues, alwaysSendFilterPropNames } = this.props
    const postData = _.clone(values)

    if (_.has(initialValues, 'Filters') & _.has(values, 'Filters')) {
      // build filters based on inital values
      postData.Filters = {}
      const filterKeys = _.keys(initialValues.Filters)
      console.log(alwaysSendFilterPropNames)

      for (var filterKey of filterKeys) {
        // if the key matches the always send list, don't try to filter out
        // default values
        if (_.indexOf(alwaysSendFilterPropNames || [], filterKey) !== -1) {
          postData.Filters[filterKey] = values.Filters[filterKey]
          continue
        }

        if (_.isArray(initialValues.Filters[filterKey])) {
          const filterKeyArrayCompare = componentGetCompareProps(filterKey, values.Filters, initialValues.Filters, [])
          if (filterKeyArrayCompare.Current.length === filterKeyArrayCompare.Previous.length) {
            const currentValues = _.map(filterKeyArrayCompare.Current, 'Value')
            const previousValues = _.map(filterKeyArrayCompare.Previous, 'Value')
            const diffs = _.difference(currentValues, previousValues)
            if (diffs.length > 0) {
              postData.Filters[filterKey] = filterKeyArrayCompare.Current
            }
          } else {
            postData.Filters[filterKey] = filterKeyArrayCompare.Current
          }
        } else {
          const filterKeyCompare = componentGetCompareProps(filterKey, values.Filters, initialValues.Filters, {})
          if (filterKeyCompare.Current.Value !== filterKeyCompare.Previous.Value) {
            postData.Filters[filterKey] = filterKeyCompare.Current
          }
        }
      }
    }

    if (_.isFunction(onSubmit)) {
      onSubmit(postData)
    }
  }

  debouncer=_.debounce((values) => { this.onSubmit(values) }
    , 750)

  render () {
    const { formName, loading, children, initialValues, sortOptions } = this.props

    const items = this.getItems(children, sortOptions, initialValues)

    return (
      <div className={styles.root}>
        <FormBox form={formName} initialValues={initialValues} loading={loading} onSubmit={this.onSubmit.bind(this)}
          onChange={this.debouncer.bind(this)} simpleBody>
          <ListGroup>
            {items.filters}
          </ListGroup>
        </FormBox>
      </div>

    )
  }
}

export const DataGridFilter = compose(
  ReduxWrapper([
  ], [
    ah.formSetFieldValue,
    ah.formResetValues
  ])
)(DataGridFilterPlain)

export default DataGridFilter
